export const inputDesignStyles: Record<string, Record<string, string>> = {
  flat: {
    'input-background-color': '#F4F5F7',
    'input-background-color-hover': '#e9ecf0',
    'input-border-color': 'none',
    'input-box-shadow': 'none'
  },
  bordered: {
    'input-background-color': '#FFFFFF',
    'input-background-color-hover': '#FBFBFB',
    'input-border-color': '#D7DBE1',
    'input-box-shadow':
      '0px 0.27px 3.19px 0px #00000005, 0px 0.89px 10.72px 0px #00000008, 0px 4px 48px 0px #0000000D'
  }
};

export const inputRadiusStyles: Record<string, Record<string, string>> = {
  none: {
    'input-border-radius': '0rem'
  },
  rounded: {
    'input-border-radius': '0.25rem'
  }
};
